import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { passwordReset } from '../api';

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isPending, setIsPending] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setIsPending(true);
    try {
      await passwordReset.request(email);
    } catch {
      // Vi viser samme svar uanset — ingen email-enumeration
    }
    setSubmitted(true);
    setIsPending(false);
  }

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
        <div className="max-w-sm w-full bg-white rounded-lg shadow p-8 text-center space-y-4">
          <h1 className="text-2xl font-bold text-slate-900">{t('forgot.sentTitle')}</h1>
          <p className="text-slate-600">{t('forgot.sentBody')}</p>
          <Link to="/login" className="inline-block text-slate-600 hover:underline">
            {t('common.backToLogin')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <form
        onSubmit={handleSubmit}
        className="max-w-sm w-full bg-white rounded-lg shadow p-8 space-y-4"
      >
        <h1 className="text-2xl font-bold text-slate-900">{t('forgot.title')}</h1>
        <p className="text-sm text-slate-600">{t('forgot.intro')}</p>

        <label className="block">
          <span className="text-sm font-medium text-slate-700">{t('field.email')}</span>
          <input
            type="email"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 block w-full rounded border border-slate-300 px-3 py-2 focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500"
          />
        </label>

        <button
          type="submit"
          disabled={isPending}
          className="w-full bg-slate-900 text-white rounded px-4 py-2 hover:bg-slate-800 disabled:opacity-50"
        >
          {isPending ? t('common.working') : t('forgot.submit')}
        </button>

        <div className="text-center text-sm">
          <Link to="/login" className="text-slate-600 hover:underline">
            {t('common.backToLogin')}
          </Link>
        </div>
      </form>
    </div>
  );
}
